module.exports = __webpack_public_path__ + "static/leaflet2025-16b6fb31181a46889507a9d1d32d43ec.pdf";